var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "margin-bottom-4xl" }, [
    _c(
      "div",
      { staticClass: "row align-stretch" },
      _vm._l(_vm.features, function (feature) {
        return _c(
          "div",
          { key: feature.id, class: _vm.featureClass },
          [
            _c(
              feature.location.href ? "a" : "site-link",
              _vm._b(
                {
                  tag: "component",
                  class: _vm.setFeatureCardClass(feature.theme),
                  staticStyle: {
                    gap: "var(--spacing-lg)",
                    "--card-link-box-shadow-color":
                      "var(--card-link-hover-border-color)",
                    height: "100%",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleFeatureClick(feature)
                    },
                  },
                },
                "component",
                _vm.getLocationProps(feature),
                false
              ),
              [
                _c("font-awesome-icon", {
                  staticClass: "margin-right-3xs",
                  attrs: {
                    icon: _vm.$v6[feature.icon.style][feature.icon.name],
                    "fixed-width": "",
                    size: "2x",
                  },
                }),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "h3",
                    {
                      staticClass: "h6 margin-bottom-sm text-uppercase",
                      staticStyle: {
                        "letter-spacing": "var(--letter-spacing-2xl)",
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(feature.title) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "size-sm" }, [
                    _vm._v(_vm._s(feature.description)),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }